// Funzione che crea il pdf-utente con il dettaglio di una submission list
import {jsPDF} from "jspdf";
import {
  CURRENCY_EURO,
  extractVat,
  hasValidVoucher,
  homePickUpServiceEnabled,
  insuranceRequested,
  insuranceServiceEnabled,
  isInAClosingState,
  isPresent,
  parseAmount,
  parseBrandName,
  parseCategoryName,
  parseEncasing,
  parseGameName,
  parseGradeOverall,
  parseRequestedService,
  parseUserFullName,
  returnShipmentServiceEnabled,
  titleize
} from "../utils";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab = "        "
const space = " "

const writeItalicText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', 'italic')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const addFrameAndFooter = (doc, submissionList) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(10)

  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.setDrawColor(4, 159, 227)
    doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10)

    doc.setTextColor(0, 0, 0)
    if (submissionList.grader_company)
      doc.text(submissionList.grader_company.name, 10, doc.internal.pageSize.height - 10);

    doc.text(String(i), doc.internal.pageSize.width - 12, doc.internal.pageSize.height - 10)
  }
}

const getSubmissionListItemTableRow = (submissionList, submissionListItem, index, pricingFor) => {
  let name = submissionListItem.product.blueprint_image.en_name;
  if(submissionListItem.product.blueprint_image.collector_number)
    name = name + ' ' + submissionListItem.product.blueprint_image.collector_number.replaceAll(' ', '');

  const categoryName = submissionListItem.product.blueprint_image.blueprint.category.name;
  const category = parseCategoryName(categoryName);
  const game = parseGameName(submissionListItem.product.blueprint_image.game.name);

  const encasing = `${I18n.t('js.PDFGenerator.common.tableHeader.encasing')} ${parseEncasing(submissionListItem.encasing, categoryName)}`;

  const requestedService =
    I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.requestedService')
      .replace(':requested_service', parseRequestedService(submissionListItem.requested_service));

  const label =
    I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.label')
      .replace(':label_type', I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.${submissionListItem.label_type}`))
      .replace(':label_language', I18n.t(`js.common.languageAcronyms.${submissionListItem.label_language}`));

  const amountVatExcluded =
    pricingFor === 'middleman' ?
      submissionListItem.amount_vat_excluded ? parseAmount(submissionListItem.amount_vat_excluded) + CURRENCY_EURO : ''
    :
      submissionListItem.customer_amount_vat_excluded ? parseAmount(submissionListItem.customer_amount_vat_excluded) + CURRENCY_EURO : '';
  const vatRate =
    pricingFor === 'middleman' ?
      parseAmount(submissionListItem.vat_rate, 0, true) + '%'
    :
      parseAmount(submissionListItem.customer_vat_rate, 0, true) + '%';
  const amount =
    pricingFor === 'middleman' ?
      submissionListItem.amount ? parseAmount(submissionListItem.amount) + CURRENCY_EURO : ''
    :
      submissionListItem.customer_amount ? parseAmount(submissionListItem.customer_amount) + CURRENCY_EURO : '';

  let grading = '';
  if (isInAClosingState(submissionList) || submissionList.show_gradings) {
    if(isPresent(submissionListItem.rejected))
      grading = titleize(submissionListItem.rejected.replaceAll('_',' '))
    else if(submissionListItem.grading)
      grading = parseGradeOverall(submissionListItem.grading);
  }

  const itemDescription = `${name}, ${category} ${game}, ${requestedService}, ${encasing}, ${label}`;
  return [index, itemDescription, grading, amountVatExcluded, vatRate, amount];
}

const getSupplementaryItemTableRow = (submissionList, supplementaryItem, index, pricingFor) => {

  const description = supplementaryItem.description;

  const categoryName = supplementaryItem.category_name;
  const brand = parseBrandName(supplementaryItem.brand_name);
  const category = parseCategoryName(categoryName);

  const encasing = `${I18n.t('js.PDFGenerator.common.tableHeader.encasing')} ${parseEncasing(supplementaryItem.encasing, categoryName)}`;

  const requestedService =
    I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.requestedService')
      .replace(':requested_service', parseRequestedService(supplementaryItem.requested_service));

  const label =
    I18n.t('js.editSubmissionListPage.webComponent.draft.labelTypeOption.label')
      .replace(':label_type', I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.${supplementaryItem.label_type}`))
      .replace(':label_language', I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.labelLanguage_${supplementaryItem.label_language}`));

  const amountVatExcluded =
    pricingFor === 'middleman' ?
      supplementaryItem.amount_vat_excluded ? parseAmount(supplementaryItem.amount_vat_excluded) + CURRENCY_EURO : ''
      :
      supplementaryItem.customer_amount_vat_excluded ? parseAmount(supplementaryItem.customer_amount_vat_excluded) + CURRENCY_EURO : '';

  const vatRate =
    pricingFor === 'middleman' ?
      parseAmount(supplementaryItem.vat_rate, 0, true) + '%'
    :
      parseAmount(supplementaryItem.customer_vat_rate, 0, true) + '%';
  const amount =
    pricingFor === 'middleman' ?
      supplementaryItem.amount ? parseAmount(supplementaryItem.amount) + CURRENCY_EURO : ''
      :
      supplementaryItem.customer_amount ? parseAmount(supplementaryItem.customer_amount) + CURRENCY_EURO : '';

  let grading = '';
  if (isInAClosingState(submissionList) || submissionList.show_gradings) {
    if (isPresent(supplementaryItem.rejected)){
      grading = titleize(supplementaryItem.rejected.replaceAll('_',' '));
    }
  }

  const itemDescription = `${description}, ${category} ${brand}, ${requestedService}, ${encasing}, ${label}`;
  return [index - 1, itemDescription, grading, amountVatExcluded, vatRate, amount];
}


export const submissionListPDF = (submissionList, pricingFor) => {
  const doc = new jsPDF({orientation: "portrait"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')

  var img = new Image()
  img.src = '/images/logo-AIGRADING-white.png'
  doc.addImage(img, 15, 10, 100, 25)
  doc.setFontSize(22)
  doc.setTextColor(4, 159, 227)
  if (submissionList.number)
    writeItalicText(doc, I18n.t('js.PDFGenerator.submissionList.submissionListN').toUpperCase() + submissionList.number, 114, 27)

  doc.setFontSize(16)

  writeBoldText(doc, I18n.t('js.PDFGenerator.submissionList.infoUser').toUpperCase(), 33, 55)
  if (submissionList.middleman)
    writeBoldText(doc, I18n.t('js.PDFGenerator.submissionList.infoMiddleman').toUpperCase(), 125, 55)

  doc.setFontSize(10)
  doc.setTextColor(0, 0, 0)




  // Stampo su pdf i dati del clienti
  let y1 = 65

  if (submissionList.user_owner)
    doc.text(submissionList.user_owner, 12, y1)

  if (submissionList.owner_email && submissionList.owner_email !== submissionList.user_owner) {
    y1 += 5
    doc.text(submissionList.owner_email, 12, y1)
  }

  if (submissionList.created_by === 'user' && submissionList.shipment_address) {
    const x = 12;
    y1 += 10;
    doc.text(I18n.t('js.editSubmissionListPage.webComponent.draft.addressReturnDelivery'), x, y1)

    y1 += 5
    doc.text(parseUserFullName(submissionList.shipment_address.first_name, submissionList.shipment_address.last_name), x, y1)

    if (submissionList.shipment_address.co) {
      y1 += 5
      doc.text(I18n.t('js.newUserAddressForm.co') + ': ' + submissionList.shipment_address.co, x, y1)
    }

    y1 += 5
    doc.text(submissionList.shipment_address.street_square + space +
      submissionList.shipment_address.number.toString() +
      (submissionList.shipment_address.indoor ? ', ' + submissionList.shipment_address.indoor : ''), x, y1)

    y1 += 5
    doc.text(submissionList.shipment_address.cap + space +
      submissionList.shipment_address.city.toString() + space +
      (submissionList.shipment_address.province.toUpperCase() !== submissionList.shipment_address.country.toUpperCase() ? '(' + submissionList.shipment_address.province + ')' + space : '') +
      '-' + space + submissionList.shipment_address.country.toUpperCase(), x, y1)

    if (submissionList.shipment_address.phone_number) {
      y1 += 5
      doc.text(I18n.t('js.newUserAddressForm.tel') + ': ' + submissionList.shipment_address.phone_number, x, y1)
    }
  }




  // Stampo su pdf i dati dell'aggregatore (se presente)
  let y2 = 65
  if (submissionList.middleman) {
    doc.text(submissionList.middleman.business_name, doc.internal.pageSize.width / 2 + 7, y2)
    y2 += 5
    doc.text(submissionList.middleman.email, doc.internal.pageSize.width / 2 + 7, y2)
    y2 += 5
  }

  if (submissionList.created_by === 'middleman' && submissionList.shipment_address && !submissionList.hide_shipment_and_invoicing_info_to_user) {
    const x = doc.internal.pageSize.width / 2 + 7;
    y2 += 5
    doc.text(I18n.t('js.editSubmissionListPage.webComponent.draft.addressReturnDelivery'), x, y2)

    y2 += 5
    doc.text(parseUserFullName(submissionList.shipment_address.first_name, submissionList.shipment_address.last_name), x, y2)

    if (submissionList.shipment_address.co) {
      y2 += 5
      doc.text(I18n.t('js.newUserAddressForm.co') + ': ' + submissionList.shipment_address.co, x, y2)
    }

    y2 += 5
    doc.text(submissionList.shipment_address.street_square + space +
        submissionList.shipment_address.number.toString() +
        (submissionList.shipment_address.indoor ? ', ' + submissionList.shipment_address.indoor : ''), x, y2)

    y2 += 5
    doc.text(submissionList.shipment_address.cap + space +
        submissionList.shipment_address.city.toString() + space +
        '(' + submissionList.shipment_address.province + ')' + space +
        '-' + space + submissionList.shipment_address.country.toUpperCase(), x, y2)

    if (submissionList.shipment_address.phone_number) {
      y2 += 5
      doc.text(I18n.t('js.newUserAddressForm.tel') + ': ' + submissionList.shipment_address.phone_number, x, y2)
    }
  }




  // Disegno i box rettangolari che contengono i dati del cliente e dell'aggregatore
  doc.setDrawColor(4, 159, 227)
  const yRect = 60;
  const rectHeight = (Math.max(y1, y2) - yRect) + 3;
  doc.rect(10, yRect, doc.internal.pageSize.width / 2 - 10, rectHeight)
  if (submissionList.middleman)
    doc.rect(doc.internal.pageSize.width / 2 + 5, yRect, doc.internal.pageSize.width / 2 - 15, rectHeight)




  // Stampo su pdf i dati generali della submission lists
  let yPosition = Math.max(y1, y2) + 12;
  if (submissionList.confirmed_at)
    doc.text(I18n.t('js.PDFGenerator.common.confirmedAt') + space + submissionList.confirmed_at.toString(), 10, yPosition);

  if (submissionList.home_pick_up_requested && !submissionList.hide_shipment_and_invoicing_info_to_user && submissionList.home_pick_up_favorite_day_italian_format) {
    yPosition += 7
    doc.text(I18n.t('js.editSubmissionListPage.homePickUpProgrammed') + space + submissionList.home_pick_up_favorite_day_italian_format +
      (submissionList.home_pick_up_favorite_hour && submissionList.home_pick_up_favorite_hour !== 'all_day' ? (I18n.t("js.editSubmissionListPage.homePickUpProgrammed1") + space + submissionList.home_pick_up_favorite_hour.split('_')[0] + ':00 ' + I18n.t("js.editSubmissionListPage.homePickUpProgrammed2") + space + submissionList.home_pick_up_favorite_hour.split('_')[1] + ':00') : ''), 10, yPosition);
  }

  const courier = submissionList.courier
  if (submissionList.return_delivery_requested && courier && !submissionList.hide_shipment_and_invoicing_info_to_user) {
    yPosition += 7
    doc.text(I18n.t('js.editSubmissionListPage.trackingReturnDeliveryMethod') + space + courier.meta_name + (submissionList.tracking_number ? (' - ' + submissionList.tracking_number) : ''), 10, yPosition);
  }

  if (insuranceRequested(submissionList)) {
    yPosition += 7
    doc.text(I18n.t("js.indexSubmissionListsPage.insuranceOnPack") + ':' + space + I18n.t('js.common.choice_yes') + ' - ' + I18n.t("js.indexSubmissionListsPage.insuranceUpperLimit") + ' ' + parseAmount(submissionList.insured_value ? submissionList.insured_value : submissionList.estimated_value, 2) + CURRENCY_EURO, 10, yPosition);
    yPosition += 7
    doc.text(I18n.t('js.PDFGenerator.common.insuredAt') + ':' + space + submissionList.confirmed_at.toString(), 10, yPosition);
  }

  yPosition += 5


  // Stampo su pdf i dati di ogni singolo submission list item presente in submission
  let lastIndex = 0;
  let tableRowsIndexesDividers = [];
  let boldTableRowsIndexes = [];
  let supplementaryItemsTableRendered = false;
  if (submissionList.submission_list_items.length > 0 || submissionList.supplementary_items.length > 0) {
    supplementaryItemsTableRendered = true;
    var tableContent = []
    for (var i = 0; i < submissionList.submission_list_items.length; i++) {
      if (lastIndex == 0)
        tableRowsIndexesDividers.push(lastIndex);
      lastIndex = lastIndex + 1;
      tableContent.push(getSubmissionListItemTableRow(submissionList, submissionList.submission_list_items[i], lastIndex, pricingFor));
    }

    for (var i = 0; i < submissionList.supplementary_items.length; i++) {
      if (lastIndex == 0)
        tableRowsIndexesDividers.push(lastIndex);
      lastIndex = lastIndex + 1;
      tableContent.push(getSupplementaryItemTableRow(submissionList, submissionList.supplementary_items[i], lastIndex + 1, pricingFor));
    }

    tableRowsIndexesDividers.push(lastIndex);
    boldTableRowsIndexes.push(lastIndex);
    lastIndex = lastIndex + 1;
    tableContent.push([
      '',
      I18n.t('js.editSubmissionListPage.webComponent.draft.payment.subtotalVatExcluded').toUpperCase(),
      '',
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}grading_service_amount_vat_excluded`], 2, true)}${CURRENCY_EURO}`,
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true)}%`,
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}grading_service_amount`], 2, true)}${CURRENCY_EURO}`
    ])

    lastIndex = lastIndex + 1;
    const discounts =
      hasValidVoucher(submissionList) ?
        (submissionList.voucher.amount ?
          [
            '-' + parseAmount(extractVat(submissionList.voucher.amount, submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`]), 2) + CURRENCY_EURO,
            '-' + parseAmount(submissionList.voucher.amount, 2) + CURRENCY_EURO
          ]
        :
          ['-' + submissionList.voucher.percentage + '%', '-' + submissionList.voucher.percentage + '%'])
    :
      ['--', '--'];
    tableContent.push([
      '',
      I18n.t('js.editSubmissionListPage.webComponent.draft.payment.gradingServicesDiscount').toUpperCase(),
      '',
      discounts[0],
      `${discounts[0] === '--' ? discounts[0] : parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true) + '%'}`,
      discounts[1]
    ])

    if (homePickUpServiceEnabled(submissionList) || returnShipmentServiceEnabled(submissionList)) {
      lastIndex = lastIndex + 1;
      tableContent.push([
        '',
        I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping').toUpperCase(),
        '',
        `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}global_shipping_cost_vat_excluded`], 2, true)}${CURRENCY_EURO}`,
        `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true)}%`,
        `${parseAmount(submissionList.global_shipping_cost, 2, true)}${CURRENCY_EURO}`
      ])
    }

    if (insuranceServiceEnabled(submissionList)) {
      lastIndex = lastIndex + 1;
      boldTableRowsIndexes.push(lastIndex);
      tableContent.push([
        '',
        I18n.t('js.editSubmissionListPage.webComponent.draft.payment.insurance').toUpperCase(),
        '',
        `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}insurance_cost_vat_excluded`], 2, true)}${CURRENCY_EURO}`,
        `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true)}%`,
        `${parseAmount(submissionList.insurance_cost, 2, true)}${CURRENCY_EURO}`
      ])
    }

    tableRowsIndexesDividers.push(lastIndex);
    lastIndex = lastIndex + 1;
    tableContent.push([
      '',
      I18n.t('js.editSubmissionListPage.webComponent.draft.payment.totalAmount').toUpperCase(),
      '',
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}all_services_amount_vat_excluded`], 2, true)}${CURRENCY_EURO}`,
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true)}%`,
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}all_services_amount`], 2, true)}${CURRENCY_EURO}`
    ])

    lastIndex = lastIndex + 1;
    tableContent.push([
      '',
      I18n.t('js.editSubmissionListPage.webComponent.draft.payment.piggyBankUsed').toUpperCase(),
      '',
      `-${parseAmount(submissionList.user_credit_vat_excluded, 2, true)}${CURRENCY_EURO}`,
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}vat_rate`], 0, true)}%`,
      `-${parseAmount(submissionList.user_credit, 2, true)}${CURRENCY_EURO}`
    ])

    tableRowsIndexesDividers.push(lastIndex);
    boldTableRowsIndexes.push(lastIndex);
    tableContent.push([
      '',
      I18n.t('js.editSubmissionListPage.webComponent.draft.payment.amountVatIncluded').toUpperCase(),
      '', '', '',
      `${parseAmount(submissionList[`${pricingFor === 'middleman' ? '' : 'customer_'}amount`], 2, true)}${CURRENCY_EURO}`
    ])


    doc.autoTable({
      theme: 'plain',
      head: [[ '',
        I18n.t('js.editSubmissionListPage.tableHeaderItemsList').toUpperCase(),
        I18n.t('js.PDFGenerator.common.tableHeader.grading').toUpperCase(),
        I18n.t('js.PDFGenerator.common.tableHeader.priceVatExcluded'),
        I18n.t('js.PDFGenerator.common.tableHeader.vatRate').toUpperCase(),
        I18n.t('js.PDFGenerator.common.tableHeader.priceVatIncluded'),
      ]],
      margin: {left: 8, right: 8},
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 10 : yPosition,
      body: tableContent,
      didParseCell: function(data) {
        if (![0, 1, 2].includes(data.column.index))
          data.cell.styles.halign = 'right';

        if (data.cell.section === 'body' && boldTableRowsIndexes.includes(data.row.index))
          data.cell.styles.fontStyle = 'bold';
      },
      didDrawCell: function(data) {
        if (data.cell.section === 'body' && tableRowsIndexesDividers.includes(data.row.index)) {
          const { x, y, width } = data.cell;
          doc.setDrawColor(0, 0, 0); // black
          doc.line(x, y, x + width, y);
        }
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240]
      }
    });


    doc.text(I18n.t('js.editSubmissionListPage.webComponent.draft.payment.thisDocumentIsNotAnInvoice'), 10, doc.autoTableEndPosY() + 20)
  }


  addFrameAndFooter(doc, submissionList)
  var pdfName= submissionList.number ? 'Order_' + submissionList.number + '.pdf' : 'New_Order.pdf'
  doc.save(pdfName);
}